import { showSelectedModalProductHappy } from "@/happyTheme/event/product/showSelectedModalProductHappy";

export function toggleSelectedModalProductHappy() {
    const html = document.documentElement
    if (html.classList.contains("modal-open")) {
        html.classList.remove("modal-open")
    }

    showSelectedModalProductHappy.value = !showSelectedModalProductHappy.value
}